import { Chip } from '@mui/material';

const statusStyles = {
  pending: {
    bgcolor: '#FEF9C3', // yellow-100
    color: '#854D0E', // yellow-800
    border: '1px solid #FDE047', // yellow-300
    hover: '#FEF08A', // yellow-200
  },
  in_progress: {
    bgcolor: '#DBEAFE', // blue-100
    color: '#1D4ED8', // blue-700
    border: '1px solid #93C5FD', // blue-300
    hover: '#BFDBFE', // blue-200
  },
  needs_review: {
    bgcolor: '#FFEDD5', // orange-100
    color: '#C2410C', // orange-700
    border: '1px solid #FDBA74', // orange-300
    hover: '#FED7AA', // orange-200
  },
  completed: {
    bgcolor: '#DCFCE7', // green-100
    color: '#15803D', // green-700
    border: '1px solid #86EFAC', // green-300
    hover: '#BBF7D0', // green-200
  },
  failed: {
    bgcolor: '#FEE2E2', // red-100
    color: '#B91C1C', // red-700
    border: '1px solid #FCA5A5', // red-300
    hover: '#FECACA', // red-200
  },
  active: {
    bgcolor: '#DCFCE7', // green-100
    color: '#15803D', // green-700
    border: '1px solid #86EFAC', // green-300
    hover: '#BBF7D0', // green-200
  },
  in_active: {
    bgcolor: '#FEF9C3', // yellow-100
    color: '#854D0E', // yellow-800
    border: '1px solid #FDE047', // yellow-300
    hover: '#FEF08A', // yellow-200
  },
  uploading: {
    bgcolor: '#DBEAFE', // blue-100
    color: '#1D4ED8', // blue-700
    border: '1px solid #93C5FD', // blue-300
    hover: '#BFDBFE', // blue-200
  },
  cancelled: {
    bgcolor: '#FEE2E2', // red-100
    color: '#B91C1C', // red-700
    border: '1px solid #FCA5A5', // red-300
    hover: '#FECACA', // red-200
  },
};

const StatusChip = ({ status, label }) => {
  const style = statusStyles[status] || statusStyles['pending'];

  return (
    <Chip
      label={label ?? status}
      sx={{
        width: 114,
        fontWeight: 500,
        bgcolor: style.bgcolor,
        color: style.color,
        border: style.border,
        transition: 'background-color 0.2s ease',
        '&:hover': {
          bgcolor: style.hover,
        },
      }}
    />
  );
};

export default StatusChip;
